import { AmazonProductMatchMapping } from '@domain/connection/models/ConnectionSettings';
import {
  ShopifyMatchedJuststockProduct,
  ShopifySetupProductPreview,
} from '@domain/connection/models/ShopifyMatchPreview';

export type AmazonSetupProductPreview = ShopifySetupProductPreview;
export type AmazonMatchedJuststockProduct = ShopifyMatchedJuststockProduct;

export interface AmazonMatchPreviewResponse {
  mapping: AmazonProductMatchMapping;
  fieldCounts: Record<string, number>;
  productsScanned: number;
  productsFound: number;
  products: AmazonSetupProductPreview[];
  hasDuplicateValues: boolean;
  duplicateValues: string[];
  matchesFound: number;
  matches: Record<string, AmazonMatchedJuststockProduct>;
  nextPageToken?: string | null;
}

export interface AmazonMarketplaceOption {
  id: string;
  name: string;
  countryCode?: string;
  selected: boolean;
}

export interface CompleteAmazonSetupInput {
  productMatchMapping: AmazonProductMatchMapping;
  titleCountryCode?: string;
}

export interface CompleteAmazonSetupResponse {
  jobs: { jobId: string; target: string }[];
}

export interface FinishAmazonSetupInput {
  loadInventory: boolean;
}

const TARGET_BY_SOURCE: Record<string, string> = {
  ean: 'ean',
  upc: 'ean',
  gtin: 'ean',
  isbn: 'ean',
  sku: 'sku',
  asin: 'customFields.amazonAsin',
};

export function suggestAmazonTargetForSource(sourceField: string, currentTarget?: string): string {
  return TARGET_BY_SOURCE[sourceField] ?? currentTarget ?? 'sku';
}
